import { usePermissions } from '../hooks/usePermissions';
import { Banner, Card, EmptyState, PageBody, PageHeader } from './ui';

export const HumanResources = () => {
    const { canAccess, loading } = usePermissions();

    if (loading) {
        return (
            <>
                <PageHeader title="Human Resources" description="Staff and hiring." />
                <PageBody>
                    <Card>
                        <EmptyState title="Checking your access…" />
                    </Card>
                </PageBody>
            </>
        );
    }

    if (!canAccess('HR')) {
        return (
            <>
                <PageHeader title="Human Resources" description="Staff and hiring." />
                <PageBody>
                    <Banner tone="danger" title="You don't have access to Human Resources">
                        This area is for the HR office. Ask an administrator to give you the Human Resources role
                        under Administrator → People.
                    </Banner>
                </PageBody>
            </>
        );
    }

    return (
        <>
            <PageHeader title="Human Resources" description="Staff and hiring." />
            <PageBody>
                <Card>
                    <EmptyState
                        title="Human Resources tools are coming"
                        description="This section is set up and gated to the HR office. Tell me what belongs here — job applications, staff records, onboarding — and I'll build it in."
                    />
                </Card>
            </PageBody>
        </>
    );
};

export default HumanResources;
